import {
  REQUEST_NEWBUYER,
  RECEIVE_NEWBUYER,
  NEWBUYER_FAILED
} from '../actions/types';

const newbuyerRequest = (state = {}, action) => {
  switch (action.type) {
    case REQUEST_NEWBUYER:
      return Object.assign({}, state, {
        isFetching: true,
        newbuyer: {},
        error: null
      });
    case RECEIVE_NEWBUYER:
      return Object.assign({}, state, {
        isFetching: false,
        newbuyer: action.newbuyer,
        error: null
      });
    case NEWBUYER_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        newbuyer: action.newbuyer,
        error: action.error
      });
    default:
      return state;
  }
};

export default newbuyerRequest;
